var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCube = function SvgCube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.548q.477 0 .903.246l6.693 3.852a1.78 1.78 0 0 1 .904 1.562v7.585a1.77 1.77 0 0 1-.904 1.561l-6.693 3.852a1.78 1.78 0 0 1-1.806 0l-6.693-3.852a1.773 1.773 0 0 1-.904-1.561V8.208a1.77 1.77 0 0 1 .904-1.562l6.693-3.852A1.8 1.8 0 0 1 12 2.548m.15 1.534a.3.3 0 0 0-.3 0l-6.7 3.873a.3.3 0 0 0-.149.26v7.56l.01.078c.021.075.07.141.14.182l6.699 3.88.072.03c.075.021.156.012.226-.029l6.704-3.882a.29.29 0 0 0 .148-.256l-.001-7.56a.3.3 0 0 0-.15-.26z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.85 7.244a.3.3 0 0 1 .3 0l3.935 2.277c.092.054.15.152.15.259v4.438a.3.3 0 0 1-.147.258l-3.94 2.281-.072.03a.3.3 0 0 1-.154 0l-.073-.03-3.935-2.278a.3.3 0 0 1-.139-.182l-.01-.078V9.78a.3.3 0 0 1 .149-.26zm-2.836 3.082v3.344L12 15.398l2.986-1.729v-3.34L11.998 8.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.123 12.76 8.016-4.64-1.129-.792c-1.683.977-5.747 3.327-7.011 4.059L4.977 7.325l-.692 1.044 7.588 4.391.062.026a.25.25 0 0 0 .127 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.375 11.95h1.25v8.175h-1.25zM11.375 2.997h1.25v4.797h-1.25zM19.896 15.721l-.625 1.083-3.941-2.276.625-1.082zM4.73 16.804l-.626-1.083 3.941-2.275.625 1.082z"
  })));
};
export default SvgCube;